import * as React from 'react';
import { IconList } from 'ui';
import { FactLink } from 'app/area/case/components/fact-box/fact-link';
import { MdFlashOn } from 'react-icons/md';
import { FactItemProps } from 'app/area/case/components/fact-box/types';
import { ComplexValue, ComponentProps } from 'ui/common';
import { isCaseViewModalOpen } from 'app/components/helpers';

interface FactItemConsequencesProps extends ComponentProps, FactItemProps {
  childValueItems: {
    ActConsConsequenceIcons: ComplexValue<number>[];
  };
}

export const ConsequencesFactItem = (props: FactItemConsequencesProps) => {
  const { title, url, childValueItems, linkDomain, portalTarget } = props;
  const defaultIconConsequences = <MdFlashOn />;
  const icons = childValueItems?.ActConsConsequenceIcons;
  const wrapperStyleClass = icons?.length > 4 ? 'consequence-wide': '';
  if(!icons?.length){
    return null;
  }
  return <FactLink id={props.componentId} classNames={`fact-item icon-line ${wrapperStyleClass}`} section={linkDomain} url={url} 
    skipNavigation={isCaseViewModalOpen()}>
    <IconList title={title} valueItems={icons} defaultIcon={defaultIconConsequences} portalTarget={portalTarget} />
  </FactLink>;
};
